import React, {Component} from 'react'
import './gps-detail.less'
import {Table, Row, Col, Steps, message, Tabs, Popconfirm, Form, Button, DatePicker, Timeline} from 'antd'
import {reqGpsTrails} from '../../api'
import {ReactBingmaps} from 'react-bingmaps'
import moment from 'moment';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthPopconfirm = authorizeBase(Popconfirm)
let deviceId = '';
const {Step} = Steps;
const {TabPane} = Tabs;
moment.locale('zh-cn');
class GpsDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            test: "1234",
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            stepDescription: [],
            currentTrailNo: '',
            vehicleCount: 0,
            from: null,
            to: null,
            deviceId: ''
        }
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            const {from, to} = this.state
            values.from = from;
            values.to = to;
            values.deviceId = deviceId;
            if (!err) {
                this.getRightOrderTrails(values)
                this.timer_two(values)
            }
        });
    };

    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({
                activeId: id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    }
    getOrderTrails = async (data) => {
        data.type = 'normal'
        let result = await reqGpsTrails(data)
        if (result.code === 200 && result.data.length > 0) {
            let ret = []
            let ret2 = []
            result.data.forEach((item) => {
                let address =
                    '位置:' + item.address + '<br/>' +
                    '设备号:' + item.trailNo + '<br/>' +
                    '到达时间:' + item.activeDt + '<br/>' +
                    '经度:' + item.longitude + '<br/>' +
                    '纬度:' + item.latitude + '<br/>' +
                    '温度(摄氏):' + item.uTemperature + '<br/>' +
                    '电量(%):' + item.uBattery + '<br/>' +
                    '信号强度:' + item.uSignalstrength;
                ret.push({
                    "location": [item.latitude, item.longitude],
                    "addHandler": "mouseover",
                    "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                    "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                    "infoboxAddHandler": {
                        "type": "click", callback: () => {
                            this.scrollInto("step" + item.id)
                        }
                    },
                    "pushPinAddHandler": {
                        "type": "click", callback: () => {
                            this.scrollInto("step" + item.id)
                        }
                    }
                })
                ret2.push([item.latitude, item.longitude])
            });

            this.setState({
                center: ret2[0],
                infoboxesWithPushPins: ret,
                polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
            });
        } else if (result.code === 200) {
            this.setState({
                center: [],
                infoboxesWithPushPins: [],
                polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
            });
        } else {
            message.error(result.message)
        }
    }
    handleClickItem = (des) => {
        if (des.sts === 'Y') {
            this.scrollInto("step" + des.id);
            this.setState({
                center: [des.latitude, des.longitude],
                regularPolygons: [
                    {
                        "center": [des.latitude, des.longitude],
                        "radius": 6,
                        "points": 6,
                        "option": {fillColor: "rgba(0,0,0,0.4)", strokeThickness: 2}
                    }
                ],
            });
        }
    };

    getRightOrderTrails = async (data) => {
        data.type = 'all'
        let result = await reqGpsTrails(data)
        if (result.code === 200 && result.data.length > 0) {
            let description = []
            result.data.forEach(function (item) {
                let sesObj = {
                    id: item.id,
                    sts: item.sts,
                    activeDt: item.activeDt,
                    address: item.address,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    uTemperature: item.uTemperature,
                    uSignalstrength: item.uSignalstrength

                }
                description.push(sesObj)
            });
            this.setState({
                stepDescription: description
            });
        } else if (result.code === 200) {
            this.setState({
                stepDescription: []
            });
        } else {
            message.error(result.message)
        }

    }

    timer_two = (record) => setTimeout(
        () => {
            this.getOrderTrails(record)
        },
        2000
    );

    componentDidMount() {
        deviceId = this.props.location.state.deviceId;
        if (deviceId) {
            const data = {
                deviceId
            }
            this.getRightOrderTrails(data)
            this.timer_two(data);
            this.setState({
                deviceId
            })
        }
    }

    steDescription = (obj) => {
        if (obj) {
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.longitude}</div>
                <div>纬度:{obj.latitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    };

    // 日期选择
    onDateChange = (value, dateString) => {
        this.setState({
            from: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        this.setState({
            to: dateString
        })
    }

    render() {
        const form = this.props.form
        const {getFieldDecorator} = form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }
        const {stepDescription, deviceId} = this.state;

        return (
            <div className='info box-shadow padding-20'>
                <div className='info-item'>
                    <div className="info-item-title">
                        轨迹展示
                    </div>
                    <Form {...formItemLayout} onSubmit={this.handleSubmit} style={{marginTop: '10px'}}>
                        <Row>
                            <Col span={8}>
                                <Form.Item label="开始时间" className='time-input-to'>
                                    {getFieldDecorator('from')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange}
                                        style={{width: "100%", minWidth: 10}}
                                    />)}

                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="至" className='time-input-to'>
                                    {getFieldDecorator('to')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange2}
                                        style={{width: "100%", minWidth: 10}}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col span={4} style={{marginTop: '4px'}}>
                                <Button type='primary' htmlType="submit">查询</Button>
                            </Col>
                        </Row>

                    </Form>

                    {
                        deviceId ? <Tabs type="card" style={{marginTop: '10px'}}>
                            <TabPane tab={deviceId} key={deviceId}>
                            </TabPane>
                        </Tabs> : null
                    }
                    <div className='track-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={8}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins }
                                regularPolygons={this.state.regularPolygons}
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                        onClick={() => this.handleClickItem(des)}
                                        style={this.state.activeId === ("step" + des.id) ? {
                                            color: "#2975d5",
                                            paddingTop: 3
                                        } : (des.sts !== 'N' ? {
                                            color: "rgba(0, 0, 0, 0.9)",
                                            paddingTop: 3
                                        } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.steDescription(des)}</p>
                                    </Timeline.Item>
                                ))}
                            </Timeline> : null}

                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

const WrapGpsDetail = Form.create()(GpsDetail)
export default WrapGpsDetail